import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import './DonationPopup.css';
import enMessages from './popupEn.json';
import esMessages from './popupEs.json';
import homepageLogo from '../assets/img/LOGO-ilga.svg'
import { connect } from 'react-redux';

const DonationPopup = ({ isLoggedIn }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [showIframe, setShowIframe] = useState(false);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    // Set messages based on current language
    const currentLang = navigator.language || 'en';
    setMessages(currentLang.startsWith('es') ? esMessages : enMessages);
  }, []);

  useEffect(() => {
    // Only proceed if user is logged in
    if (!isLoggedIn) return;

    // Check if we've shown the popup recently
    const lastShown = localStorage.getItem('donationPopupLastShown');
    const now = new Date().getTime();
    
    // Check for test_donate URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const shouldShowTestPopup = urlParams.get('test_donate') === '1';
    
    // Show popup if it hasn't been shown in the last 7 days
    if (!lastShown || (now - parseInt(lastShown)) > 1 * 24 * 60 * 60 * 1000) { // 
      // Add 1 second delay before showing the popup
      const timer = setTimeout(() => {
        if (messages.length > 0) {
          // Select a random message
          const randomIndex = Math.floor(Math.random() * messages.length);
          setSelectedMessage(messages[randomIndex]);
          
          setIsOpen(true);
        }
      }, 1000);

      // Cleanup timer on component unmount
      return () => clearTimeout(timer);
    }
  }, [messages, isLoggedIn]);

  const handleClose = () => {
    const now = new Date().getTime();
    localStorage.setItem('donationPopupLastShown', now.toString());
    setIsOpen(false);
    setShowIframe(false);
  };

  const handleDonateClick = () => {
    setShowIframe(true);
  };

  if (!selectedMessage) return null;

  return (
    <Modal
      isOpen={isOpen}
      closeModal={handleClose}
      title={showIframe ? null : selectedMessage.title}
    >
      <div className="donation-content">
        {!showIframe ? (
          <>
            <div 
              className="donation-text"
              dangerouslySetInnerHTML={{ __html: selectedMessage.content }}
            />
            
            <div className="donation-buttons">
              <button 
                className="donation-button donate-button"
                onClick={handleDonateClick}
              >
                Donate now
              </button>

              
              <button 
                className="donation-button later-button"
                onClick={handleClose}
              >
                Maybe later
              </button>
            </div>

            <p className="footer-text">
              You can also donate anytime through our{' '}
              <a 
                href="https://ilga.org/donate" 
                className="donation-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                donation page
              </a>
            </p>

            <p className="footer-text">
              If you are based in the USA or UK, you can donate to support the ILGA World Database and receive a donation or GiftAid receipt by{' '}
              <a 
                href="https://www.globalgiving.org/projects/ilgaworld-database/" 
                className="donation-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                clicking here
              </a>.
            </p>
          </>
        ) : (
          <div className="donorbox-embed">
            <img 
                src={homepageLogo}
                alt="ILGA World Database" 
                style={{ 
                  maxWidth: '200px', 
                  marginBottom: '2rem',
                  marginTop: '1rem'
                }} 
              />
              <iframe
                src="https://donorbox.org/embed/support-the-ilga-world-database?amount=30"
                name="donorbox"
                allowpaymentrequest="allowpaymentrequest"
                seamless="seamless"
                frameBorder="0"
                scrolling="no"
                height="200px"
                width="100%"
                style={{ maxWidth: '500px', minWidth: '250px', maxHeight: 'none !important' }}
                allow="payment"
              ></iframe>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default connect(
  (state) => ({
    isLoggedIn: state.users.logged_in
  })
)(DonationPopup); 